(function () {

  function initBundleSoldOutLabels() {

    const productJson = document.querySelector('[id^="ProductJson-"]');
    if (!productJson) return;

    let product;

    try {
      product = JSON.parse(productJson.textContent);
    } catch (e) {
      console.error("Bundle Sold Out: Unable to parse ProductJson.", e);
      return;
    }

    if (!product.options || !product.variants) return;

    // Build availability lookup once
    const availability = product.options.map(() => ({}));

    product.variants.forEach(function (variant) {

      product.options.forEach(function (_, index) {

        const value = variant["option" + (index + 1)];

        if (!value) return;

        if (!(value in availability[index])) {
          availability[index][value] = false;
        }

        if (variant.available) {
          availability[index][value] = true;
        }

      });

    });

    // Apply SOLD OUT labels
    document.querySelectorAll(".product-form__option").forEach(function (wrapper, index) {

      const lookup = availability[index];
      if (!lookup) return;

      wrapper.querySelectorAll("option").forEach(function (option) {

        const value = option.value.trim();

        option.textContent = lookup[value]
          ? value
          : value + " - SOLD OUT";

      });

    });

  }

  function waitForBundleOptions() {

    let attempts = 0;
    const maxAttempts = 40; // ~2 seconds max

    const timer = setInterval(function () {

      attempts++;

      const productJson = document.querySelector('[id^="ProductJson-"]');
      const options = document.querySelectorAll(".product-form__option option");

      if (productJson && options.length) {

        clearInterval(timer);
        initBundleSoldOutLabels();

      }

      if (attempts >= maxAttempts) {
        clearInterval(timer);
      }

    }, 50);

  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", waitForBundleOptions);
  } else {
    waitForBundleOptions();
  }

})();